import React, { useState } from "react";
import {
  NavbarButton,
} from "../navbarComponents";
import UploadFile from "./UploadFile";

const GeneralRegistersNavbar = () => {
  const [modalOpened, setModalOpened] = useState(false);

  const closeModal = () => {
    setModalOpened(false);
  };

  const openModal = () => {
    setModalOpened(true);
  };

  return (
    <React.Fragment>
      <NavbarButton onClick={() => openModal()} color="info" breakpoint={444}>
        Imagem de Fundo
      </NavbarButton>

      <UploadFile isOpen={modalOpened} toggleModal={closeModal} />
    </React.Fragment>
  );
};

export default GeneralRegistersNavbar;
